import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, inject, ChangeDetectorRef } from '@angular/core';
import { saveAs } from 'file-saver';
import { ArchivoListar, Documents, ExtensionEnum } from '../../../class/archivo.inteface';
import { Subscription } from 'rxjs';
import { ModalVisualizaArchivosService } from '../visualiza-archivos/modal-visualiza-archivos.service';
import { ListaArchivosService } from '../lista-archivos.service';
import { AppModule } from '../../../../app-module';
import { AlertService } from '../../alert/alert.service';
const CLASIFICACIONES: Record<number, string> = {
  0: 'Sin Clasificación',
  1: 'Determinación Judicial',
  2: 'Anexo Determinación Judicial',
  3: 'Promociones',
  4: 'Notificaciones',
  5: 'Intercambio CJF',
  6: 'Oficio Interconexión',
  7: 'Demanda Electrónica'
};
const TRIBUTOSTIPO = [
  { ext: ExtensionEnum.pdf, mime: 'application/pdf', icono: 'fa-file-pdf', color: 'pdf' },
  { ext: ExtensionEnum.doc, mime: 'application/msword', icono: 'fa-file-word', color: 'word' },
  { ext: ExtensionEnum.docx, mime: 'application/msword', icono: 'fa-file-word', color: 'word' },
  { ext: ExtensionEnum.png, mime: 'image/png', icono: 'fa-file-image', color: 'image' },
  { ext: ExtensionEnum.jpg, mime: 'image/jpgl', icono: 'fa-file-image', color: 'image' }
];

@Component({
  selector: 'oaj-lista-archivos-itx',
  templateUrl: './lista-archivos.component.html',
  styleUrls: ['./lista-archivos.component.css'],
  imports: [AppModule],
  providers: [ListaArchivosService, ModalVisualizaArchivosService, AlertService]
})
export class ListaArchivosComponent implements OnInit, OnDestroy {
  listaAr: ArchivoListar[] = [];
  SelectedId = -1;

  @Input() verBorrar = true;
  @Input() verPrevisualizar = false;
  @Input() obtAccionDesc = false;
  @Input() OcultaSystemName = false;
  @Input() downloadfile = true;
  @Input() verArchivoEnvio = false;

  @Input() verClasificacion = false;
  @Input() downloagOrg = false;

  @Input()
  set archivos(list: Documents[]) {
    // console.log("list:::", list);
    this.listaAr = [];
    if (list !== undefined && list.length > 0) {
      list.forEach(arch => {
        const atrib = TRIBUTOSTIPO.filter(x => x.ext === arch.extension)[0];
        const nuevoArc: ArchivoListar = {
          IdDocumento: arch.id,
          NombreSistema: arch.nombreSistema + '.' + ExtensionEnum[arch.extension],
          NombreSistemaAux: arch.nombreSistema,
          NombreOriginal: arch.nombreReal,
          Extension: ExtensionEnum[arch.extension],
          TamanioKB: arch.tamanio,
          claseIcono: atrib?.icono,
          claseColor: atrib?.color,
          mimeType: atrib?.mime,
          EstatusDescarga: false,
          idSolicitud: arch?.idTransaction ?? 0,
          Guid: arch.guid,
          iClasificacion: arch.iClasificacion,
          isAcuerdoSISE: arch.isAcuerdoSISE,
          extOriginal: arch.extOriginal,
          isLaboral: arch.isLaboral
        };

        this.listaAr.push(nuevoArc);
      });

    } else {
      console.warn('Sin datos');
    }

  }

  @Output() BorraDoc = new EventEmitter<any>();
  @Output() DescargaDoc = new EventEmitter<string>();
  lstSubscriptions: Subscription[] = [];

  private srvFiles: ListaArchivosService = inject(ListaArchivosService);
  private modalVisualizaArchivosService: ModalVisualizaArchivosService = inject(ModalVisualizaArchivosService);
  private alertService: AlertService = inject(AlertService);
  private changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  ngOnInit(): void {
    //Validar si se oculta nombre sistema para asignar extencion correcta:
    if (this.OcultaSystemName) {
      this.listaAr.forEach((file) => file.NombreOriginal = (file.NombreOriginal.split('.').slice(0, -1).join('.')) + (file.Extension.includes('.') ? file.Extension : '.' + file.Extension));
    }

  }

  /**
   * Descarga un archivo por su ID, se filtra la lista de archivos para encontrar el archivo correspondiente al ID proporcionado, si se encuentra se marca el estado de descarga del archivo como verdadero, luego se hace una llamada al servicio para obtener el archivo, si la descarga es exitosa se convierte la respuesta en un blob y se guarda el archivo utilizando la función saveAs, si ocurre un error durante la descarga se muestra un mensaje de error utilizando el servicio de alertas
   * @param idArchivo 
   */
  descargarArchivo(idArchivo: string) {
    this.cancelOutstandingRequestsA();
    // console.log('Id de Archivo para descarga', idArchivo);

    const filtrado = this.listaAr.filter(x => x.IdDocumento === idArchivo);
    if (filtrado.length > 0) {
      filtrado[0].EstatusDescarga = true;

      const subscription = this.srvFiles.getArchivo(idArchivo, this.downloagOrg)
        .subscribe((response: any) => {
          //  console.log(response);
          filtrado[0].EstatusDescarga = false;

          const base64str: string = response.data.base64File;

          const binary = atob(base64str.replace(/\s/g, ''));
          const len = binary.length;
          const buffer = new ArrayBuffer(len);
          const view = new Uint8Array(buffer);
          for (let i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
          }

          // create the blob object with content-type "application/pdf"
          const blob = new Blob([view], { type: filtrado[0].mimeType });

          // Guardado de Archivo
          // if (this.OcultaSystemName) {
          saveAs(blob, filtrado[0].NombreOriginal);
          //  }
          //  else {
          //    saveAs(blob, filtrado[0].NombreSistema);
          //  }

          if (this.obtAccionDesc) {
            this.DescargaDoc.emit(idArchivo);
          }
           this.changeDetectorRef.detectChanges();
        }, (error: any) => {
          this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
        });
      this.lstSubscriptions.push(subscription);
    }

  }

  /**
   * Muestra un archivo en una modal de visualización, se filtra la lista de archivos para encontrar el archivo correspondiente al ID proporcionado, si se encuentra se llama al servicio de visualización de archivos para mostrar el archivo
   * @param idArchivo 
   */
  mostrarArchivo(idArchivo: string) {

    const filtrado = this.listaAr.filter(x => x.IdDocumento === idArchivo);
    if (filtrado.length > 0) {
      this.modalVisualizaArchivosService.preview(idArchivo, filtrado[0].mimeType, /*filtrado[0].NombreSistema*/filtrado[0].NombreOriginal, this.downloadfile, false, 0, this.downloagOrg, false)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars  
        .then((confirm) => {
          //bloque no necesario
        }).catch(() =>
          console.error('Ocurrió un error con la modal de iframe', { autoClose: true, keepAfterRouteChange: false })
        );
    }

  }

  /**
   * Elimina un archivo de la lista, se emite un evento para notificar la eliminación del archivo
   * @param Archivo 
   */
  bajaArchivo(Archivo: any) {
    this.BorraDoc.emit(Archivo);
  }

  ngOnDestroy() {
    this.cancelOutstandingRequestsA();
  }

  cancelOutstandingRequestsA() {
    this.lstSubscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
    this.lstSubscriptions = [];
  }

  getClasificacionDescripcion(iClasificacion?: number): string {
    if (iClasificacion === null || iClasificacion === undefined) {
      return CLASIFICACIONES[0]; // SinClasificacion por default
    }
    return CLASIFICACIONES[iClasificacion] ?? CLASIFICACIONES[0];
  }

  /**
   * Descarga un archivo de acuerdo por su nombre y tipo, se filtra la lista de archivos para encontrar el archivo correspondiente al nombre proporcionado, si se encuentra se marca el estado de descarga del archivo como verdadero, luego se hace una llamada al servicio para obtener el archivo, si la descarga es exitosa se convierte la respuesta en un blob y se guarda el archivo utilizando la función saveAs, si ocurre un error durante la descarga se muestra un mensaje de error utilizando el servicio de alertas
   * @param nombreArchivo 
   * @param isLaboral 
   */
  descargarArcuerdo(nombreArchivo: string, isLaboral: boolean) {
    this.cancelOutstandingRequestsA();
    //  console.log('Archivo para descarga', nombreArchivo);

    const filtrado = this.listaAr.filter(x => x.NombreOriginal === nombreArchivo);
    if (filtrado.length > 0) {
      filtrado[0].EstatusDescarga = true;

      if (filtrado[0].extOriginal === undefined || filtrado[0].extOriginal === null) {
        filtrado[0].extOriginal = 0;
      }
      if (!isLaboral) { //SOLO SISE
        const subscription = this.srvFiles.getArchivoAcuerdo(nombreArchivo, filtrado[0].extOriginal)
          .subscribe((response: any) => {
            filtrado[0].EstatusDescarga = false;

            const base64str: string = response.data.base64File;

            const binary = atob(base64str.replace(/\s/g, ''));
            const len = binary.length;
            const buffer = new ArrayBuffer(len);
            const view = new Uint8Array(buffer);
            for (let i = 0; i < len; i++) {
              view[i] = binary.charCodeAt(i);
            }

            // create the blob object with content-type "application/pdf"
            const blob = new Blob([view], { type: filtrado[0].mimeType });
            // Guardado de Archivo
            if (this.OcultaSystemName) {
              saveAs(blob, response.data.nombreReal);
            }
            else {
              saveAs(blob, response.data.systemName);
            }

            if (this.obtAccionDesc) {
              this.DescargaDoc.emit(nombreArchivo);
            }
             this.changeDetectorRef.detectChanges();
          }, (error: any) => {
            this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
          });
        this.lstSubscriptions.push(subscription);
      }
      else { //SOLO SIGE
        const subscription = this.srvFiles.getArchivoAcuerdoLab(nombreArchivo, filtrado[0].extOriginal)
          .subscribe((response: any) => {
            filtrado[0].EstatusDescarga = false;

            const base64str: string = response.data.base64File;

            const binary = atob(base64str.replace(/\s/g, ''));
            const len = binary.length;
            const buffer = new ArrayBuffer(len);
            const view = new Uint8Array(buffer);
            for (let i = 0; i < len; i++) {
              view[i] = binary.charCodeAt(i);
            }

            // create the blob object with content-type "application/pdf"
            const blob = new Blob([view], { type: filtrado[0].mimeType });
            // Guardado de Archivo
            if (this.OcultaSystemName) {
              saveAs(blob, response.data.nombreReal);
            }
            else {
              saveAs(blob, response.data.systemName);
            }

            if (this.obtAccionDesc) {
              this.DescargaDoc.emit(nombreArchivo);
            }
             this.changeDetectorRef.detectChanges();
          }, (error: any) => {
            this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
          });
        this.lstSubscriptions.push(subscription);
      }

    }
  }

  /**
   * Muestra un acuerdo en una modal de visualización, se filtra la lista de archivos para encontrar el archivo correspondiente al nombre proporcionado, si se encuentra se llama al servicio de visualización de archivos para mostrar el archivo
   * @param NombreOriginal 
   * @param isLaboral 
   */
  mostrarDoctoAcuerdo(NombreOriginal: string, isLaboral: boolean) {
    //console.log('Archivo para descarga', NombreOriginal);


    const filtrado = this.listaAr.filter(x => x.NombreOriginal === NombreOriginal);
    if (filtrado.length > 0) {
      if (filtrado[0].extOriginal === undefined || filtrado[0].extOriginal === null) {
        filtrado[0].extOriginal = 0;
      }


      this.modalVisualizaArchivosService.preview(NombreOriginal, filtrado[0].mimeType, filtrado[0].NombreSistema, this.downloadfile, true, filtrado[0].extOriginal, this.downloagOrg, isLaboral)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .then((confirm) => {
          // bloque no requerido
        }).catch(() => console.error('Ocurrió un error con la modal de iframe', { autoClose: true, keepAfterRouteChange: false }));
    }

  }


}
